/* eslint-disable camelcase */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { http } from 'hiya-common/src/utils/axios'
import type { Svip6GuessBaseData } from './interface'

// 拉取活动基础数据
export const get_base_data = createAsyncThunk(
  'Svip6Guess/get_base_data',
  async (arg, store: any) => {
    const resp = await http.post(
      '/activity/api/svip_guessing/v1/get_base_data',
      {
        ...store.getState().env.deviceinfo,
      },
      { xcErrorToast: true },
    )
    return resp.data
  },
)

// 选择候选人
export const choose_candidate = createAsyncThunk(
  'Svip6Guess/choose_candidate',
  async (params: { candidate_mid: number }, store: any) => {
    const { activity_id } = store.getState().Svip6Guess
    const resp = await http.post(
      '/activity/api/svip_guessing/v1/choose_candidate',
      {
        ...store.getState().env.deviceinfo,
        candidate_mid: params.candidate_mid,
        activity_id,
      },
      { xcErrorToast: true },
    )
    const result = resp.data?.data ?? resp.data
    if (result?.err_code === 1) {
      // 提交成功后刷新列表与按钮态
      await store.dispatch(get_base_data())
    }
    return result
  },
)

// 页面初始 state（字段与 get_base_data 对齐）
const initialState: Svip6GuessBaseData = {
  err_msg: '',
  activity_id: 0,
  activity_start: 0,
  activity_end: 0,
  target_level: 0,
  target_open_points: 0,
  is_activity_open: false,
  activity_status: 'not_started',
  can_choose: false,
  candidate_list: [],
}

const Svip6GuessSlice = createSlice({
  name: 'Svip6Guess',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_base_data.fulfilled, (state, action) => {
      // 接口外层 ret/msg/data，业务字段在 data 内
      const data = action.payload?.data ?? action.payload
      Object.assign(state, data)
    })
  },
})

export default Svip6GuessSlice.reducer
